import { View } from "@react-pdf/renderer";
import PdfSignatureImage from "../../components/PdfSignatureImage";
import PdfLabel from "../../components/typography/PdfLabel";
import PdfValue from "../../components/typography/PdfValue";

const PdfBuilderSectionSignature = ({
  submissionDate,
  fullName,
  label,
  signature,
}) => {
  return (
    <View style={{ marginTop: 20, marginBottom: 10 }}>
      {label && <PdfLabel>{label}</PdfLabel>}
      <PdfSignatureImage src={signature} />
      {fullName && <PdfValue>{fullName}</PdfValue>}
      {submissionDate && (
        <PdfValue type={"date"}>Date: {submissionDate}</PdfValue>
      )}
    </View>
  );
};

export default PdfBuilderSectionSignature;
